import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Product } from "../../Model/ProductModel";

type ProductState = {
  list: Product[];
  dirtyIds: number[];
};

const initialState: ProductState = {
  list: [],
  dirtyIds: [],
};

const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    setProducts: (state, action: PayloadAction<Product[]>) => {
      state.list = action.payload;
      state.dirtyIds = [];
    },
    addProducts: (state, action: PayloadAction<Product[]>) => {
      state.list.push(...action.payload);
    },
    updateProduct: (state, action: PayloadAction<Product>) => {
      const index = state.list.findIndex(p => p.id === action.payload.id);
      if (index !== -1) {
        state.list[index] = action.payload;
        if (action.payload.id !== null && !state.dirtyIds.includes(action.payload.id)) {
          state.dirtyIds.push(action.payload.id);
        }
      }
    },
    updateProducts: (state, action: PayloadAction<Product[]>) => {
      action.payload.forEach(updatedProduct => {
        const index = state.list.findIndex(product => product.id === updatedProduct.id);
        if (index !== -1) {
          state.list[index] = updatedProduct;
        }
      });
    },
    markProductDirty: (state, action: PayloadAction<number>) => {
      if (!state.dirtyIds.includes(action.payload)) {
        state.dirtyIds.push(action.payload);
      }
    },
    markProductsClean: (state, action: PayloadAction<number[]>) => {
      state.dirtyIds = state.dirtyIds.filter(id => !action.payload.includes(id));
    },
    clearAllDirty: (state) => {
      state.dirtyIds = [];
    },
    deleteProducts: (state, action: PayloadAction<number[]>) => {
      state.list = state.list.filter(
        product => product.id !== null && !action.payload.includes(product.id)
      );
      state.dirtyIds = state.dirtyIds.filter(id => !action.payload.includes(id));
    },
    resetProduct: () => initialState,
  }
});

export const {
  setProducts,
  addProducts,
  updateProduct,
  updateProducts,
  markProductDirty,
  markProductsClean,
  clearAllDirty,
  deleteProducts,
  resetProduct,
} = productSlice.actions;

export default productSlice.reducer;
